import React from 'react'
import times from 'lodash/times'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'

export const BidsTableRowLoadingState = () => (
  <Box pt={2}>
    {times(3).map(item => (
      <Box key={item} pb={2}>
        <Skeleton variant='rectangular' height='75px' />
      </Box>
    ))}
  </Box>
)
